<template>
  <div>
    <v-tooltip right color="grey" v-if="!isXs">
      <template v-slot:activator="{ on, attrs }">
        <a v-bind="attrs" v-on="on" href="#" :id="pageChartId + '-download-pdf'">
          <v-btn fab icon>
            <v-img class="" src="/img/icons/pdf.svg" max-width="24"></v-img>
          </v-btn>
        </a>
      </template>
      دریافت PDF
    </v-tooltip>

    <v-tooltip right color="grey">
      <template v-slot:activator="{ on, attrs }">
        <a v-bind="attrs" v-on="on" :id="pageChartId + '-download'" :download="pageChartId + '.png'" href="">
          <v-btn fab icon>
            <v-img class="" src="/img/icons/chart_download.svg" max-width="21"></v-img>
          </v-btn>
        </a>
      </template>
      دریافت نمودار
    </v-tooltip>
  </div>
</template>

<script>

import {jsPDF} from "jspdf";

export default {
  name: "ChartExportBtn",
  props: {
    pageChartId: {
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
    let exportChart = `${this.pageChartId}`
    document.getElementById(`${this.pageChartId}-download`).addEventListener('click', function () {
      var base64_url = document.getElementById(`${exportChart}`).toDataURL("image/png");
      this.href = base64_url;
    });
    if (!this.isXs) {
      $(`#${this.pageChartId}-download-pdf`).click(function(event) {
        const pageChart = document.getElementById(`${exportChart}`)
        const doc = new jsPDF('l', 'px', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const image = pageChart.toDataURL("image/png")
        const widthRatio = pageWidth / pageChart.width;
        const heightRatio = pageHeight / pageChart.height;
        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
        const canvasWidth = pageChart.width * ratio;
        const canvasHeight = pageChart.height * ratio;
        doc.rect(10, 10, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 20, 'S');
        doc.addImage(image, 'PNG', 20, 80, canvasWidth - 40, canvasHeight);
        doc.save(`${exportChart}.pdf`);
      });
    }

  },
  watch: {
  },
  methods: {
    downloadChartAsPng() {
    },
  },
};
</script>

<style lang="scss">
</style>
